import skOptimizely from '../analytics/sk-optimizely.js';

window.addEventListener('load', function() {
  document.querySelector('#free-trial button').addEventListener('click', function(e) {
    skOptimizely.pushEvent('PP-Click-lowerCTA');
  });
})
